export default __webpack_public_path__ + "static/media/createTaskImage.148e9876.svg";